/* import React, { useState } from 'react';

const StyleSwitcher = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isDark, setIsDark] = useState(false);
  const [isBoxed, setIsBoxed] = useState(false);

  const toggleSwitcher = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  const handleThemeChange = (e, theme) => {
    e.preventDefault();
    if (theme === 'notech-dark') {
      setIsDark(true);
      // Dynamically add the dark theme stylesheet
      if (!document.getElementById('dark-theme-style')) {
        const link = document.createElement('link');
        link.rel = 'stylesheet';
        link.href = 'assets/css/notech-dark.css';
        link.id = 'dark-theme-style';
        document.head.appendChild(link);
      }
    } else {
      setIsDark(false);
      // Remove the dark theme stylesheet
      const link = document.getElementById('dark-theme-style');
      if (link) {
        link.remove();
      }
    }
  };

  const handleLayoutChange = (e) => {
    e.preventDefault();
    const newBoxedState = !isBoxed;
    setIsBoxed(newBoxedState);
    if (newBoxedState) {
      document.body.classList.add('boxed-wrapper');
    } else {
      document.body.classList.remove('boxed-wrapper');
    }
  };

  return (
    <div className={`style-switcher ${isOpen ? 'opened' : ''}`}>
      <a href="#!" id="switcher-toggler" onClick={toggleSwitcher}>
        <i className="fa fa-cog"></i>
      </a>
      <h3>Layout Options</h3>
      <div className="layout-feature" id="colorMode">
        <a
          href="#!"
          className={`dark-switcher ${isDark ? 'active' : ''}`}
          data-theme="notech-dark"
          onClick={(e) => handleThemeChange(e, 'notech-dark')}
        >
          Dark
        </a>
        <a
          href="#!"
          className={`light-switcher ${!isDark ? 'active' : ''}`}
          data-theme="notech-light"
          onClick={(e) => handleThemeChange(e, 'notech-light')}
        >
          Light
        </a>
        <button
          className={`boxed-switcher ${isBoxed ? 'active' : ''}`}
          onClick={handleLayoutChange}
        >
          {isBoxed ? 'Wide' : 'Boxed'}
        </button>
      </div>
    </div>
  );
};

export default StyleSwitcher;
 */

import React, { useState } from 'react';

const StyleSwitcher = () => {
  const [isSwitcherOpen, setIsSwitcherOpen] = useState(false);

  const handleSwitcherToggle = () => {
    setIsSwitcherOpen(!isSwitcherOpen);
  };

  return (
    <div className={`style-switcher ${isSwitcherOpen ? 'active' : ''}`}>
      <a href="#!" id="switcher-toggler" onClick={handleSwitcherToggle}><i className="fa fa-cog"></i></a>
      <h3>Layout Options</h3>
      <div className="layout-feature" id="colorMode">
        <a href="#!" className="dark-switcher" data-theme="notech-dark">Dark</a>
        <a href="#!" className="light-switcher" data-theme="notech-light">Light</a>
        <button className="boxed-switcher">Boxed</button>
      </div>
    </div>
  );
};

export default StyleSwitcher;
